import { Text, View } from '@react-pdf/renderer';
import { diasDeSemanaUtil } from '../../../../helpers';
import { cellPdf, stylesPdf } from '../../../pdfs';
import { columnsReportesAsistencias } from './ReportesAsistencias';

const columnWidths = {
  dni: 11,
  fullname: 30,
  nivel: 13,
  seccion: 7,
  docente: 17,
  materia: 17,
  horario: 15,
};

const row = (columns, el, i) => {
  return (
    <View style={stylesPdf.row}>
      {cellPdf({
        value: i,
        width: '5%',
      })}
      {columns.map((column, index) => {
        let data;
        const isUltimo = columns.length - 1 === index;

        if (column.id === 'dni') {
          data = el.estudiante.usuario.perfil.dni;
        }

        if (column.id === 'fullname') {
          data = `${el.estudiante.usuario.perfil.pnombre} ${
            el.estudiante.usuario.perfil.snombre ?? ''
          } ${el.estudiante.usuario.perfil.papellido} ${
            el.estudiante.usuario.perfil.sapellido ?? ''
          }`;
        }

        if (column.id === 'nivel') {
          data = el.horario.seccion.nivelAcademico.nombre;
        }

        if (column.id === 'seccion') {
          data = el.horario.seccion.nombre;
        }

        if (column.id === 'docente') {
          data = `${el.horario.docente.usuario.perfil.pnombre} ${
            el.horario.docente.usuario.perfil.snombre ?? ''
          } ${el.horario.docente.usuario.perfil.papellido} ${
            el.horario.docente.usuario.perfil.sapellido ?? ''
          }`;
        }

        if (column.id === 'materia') {
          data = el.horario.materia.nombre;
        }

        if (column.id === 'horario') {
          const dia = diasDeSemanaUtil.find((e) => e.dia === el.horario.dia);
          data = `${dia.abrev}: ${el.horario.horaInicio} - ${el.horario.horaFinal}`;
        }

        return cellPdf({
          value: data,
          width: `${columnWidths[column.id]}%`,
          stylesCell: {
            borderRightWidth: isUltimo ? 1 : 0,
          },
        });
      })}
    </View>
  );
};

function header(columns) {
  return (
    <View style={stylesPdf.row}>
      {cellPdf({
        value: 'Nro',
        width: '5%',
        bold: true,
        color: '#D6D6D6',
        stylesCell: {
          borderTopWidth: 1,
        },
      })}
      {columns.map((column, index) => {
        const isUltimo = columns.length - 1 === index;
        return cellPdf({
          value: column.name,
          width: `${columnWidths[column.id]}%`,
          bold: true,
          color: '#D6D6D6',
          stylesCell: {
            borderTopWidth: 1,
            borderRightWidth: isUltimo ? 1 : 0,
          },
        });
      })}
    </View>
  );
}

const TablaReportesAsistencias = ({ data, columnSelect }) => {
  const columns = [];
  columnSelect.map((el) =>
    columns.push(columnsReportesAsistencias.find((e) => e.id === el)),
  );

  return (
    <View style={stylesPdf.section}>
      <View style={{ paddingBottom: 10 }}>
        <Text style={stylesPdf.title}>LISTA DE ASISTENCIAS</Text>
      </View>
      {header(columns)}
      {data.map((el, i) => row(columns, el, i + 1))}
    </View>
  );
};

export default TablaReportesAsistencias;
